import { render, staticRenderFns } from "./ReList.vue?vue&type=template&id=039a384d"
import script from "./ReList.vue?vue&type=script&lang=js"
export * from "./ReList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports